import { Component, OnInit, Input, ViewEncapsulation, EventEmitter, Output } from '@angular/core';
import { MatSelectChange } from '@angular/material';

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class SelectComponent {

    @Input() id: string;
    @Input() label: string;
    @Input() value: string;
    @Input() canSelectMultipleValues: boolean;
    @Input() options: {[field: string]: string};
    @Input() disabled: boolean;

    @Output() valueChanged: EventEmitter<string> = new EventEmitter();

    constructor() { }

    getOptionsKey() {
        return Object.keys(this.options).map(key => key);
    }

    onSelectChange(event: MatSelectChange) {
        this.valueChanged.emit(event.value);
    }

}
